import { ComponentPropsWithoutRef } from 'react';
import cn from 'classnames';

import Button from '@/components/common/Button';

type Props = {
  buttonSize: 'small' | 'medium' | 'large';
} & ComponentPropsWithoutRef<'button'>;

const BUTTON_SIZE = {
  small: 's',
  medium: 'm',
  large: 'l'
} as const;

const TooltipButton = ({ buttonSize, ...props }: Props) => {
  return (
    <Button className={cn('btn_tooltip', props.className)}>
      <span className={`ico_wallet ico_tooltip1_${BUTTON_SIZE[buttonSize]}`}>안내</span>
    </Button>
  );
};

export default TooltipButton;
